<template>
  <!-- 网站公告 -->
  <div v-if="notice" class="home-notice">
    <div class="notice">
      <div class="notice-box">
        <div class="move-box">
          <div class="move">{{notice}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'home-notice',
    data () {
      return {
        cityId: window.store.get('city_id'),
        notice: ''
      }
    },
    mounted () {
      this.load()
    },
    methods: {
      load () {
        let self = this
        if(!self.cityId)
          return false
        self.$http.get(self.host + '/api/b796cfb5c729a3a8', {
          params: {
            cityId: self.cityId
          }
        }).then(function (res) {
          if (res.code == 1) {
            self.notice = res.data
          } else {
            self.notice = ''
          }
        }, function (error) {
          console.log(error)
        })
      }
    }
  }
</script>
<style scoped>

  .home-notice {
    width: 100%;
    height: 1rem;
  }

  .notice {
    background-color: #ffe32a;
    position: fixed;
    width: 100%;
    color: #000;
    overflow: hidden;
    z-index: 2;
    left: 0;
    right: 0;
  }

  .notice .notice-box {
    margin: .1rem;
    height: .8rem;
    overflow: hidden;
    background-color: #fff;
    border-radius: .1rem;
    line-height: .8rem;
    display: flex;
  }

  .move-box {
    position: relative;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    white-space: nowrap;
    height: .8rem;
    line-height: .8rem;
  }

  .move {
    position: absolute;
    top: 0;
    left: 100%;
    white-space: nowrap;
    animation: moveAni 15s infinite linear normal;
    height: .8rem;
    font-size: .4rem;
    line-height: .9rem;
    color: #f0250f;
  }

  @keyframes moveAni {
    0% {
      left: 100%;
    }
    100% {
      left: -150%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/home-notice.vue